module.exports = __webpack_public_path__ + "img/headline.48165f5f.png";